<template>
	<div class="pd20">
		<!-- 面包屑 -->
		<div style="margin-top: 15px">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item v-for="item in topList" :key="item.path">{{ item.name }}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="table-minheight">
			<!-- 搜索筛选 -->
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="模块名称：">
					<el-input clearable v-model="formInline.moduleName" size="small" placeholder="请输入模块名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">查询</el-button>
					<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right; margin-right: 0">
					<el-button size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button>
					<el-popover placement="bottom" title="列筛选" trigger="click" style="margin-left: 10px" width="220">
						<el-checkbox-group v-model="checkedColumns" size="mini">
							<el-checkbox v-for="item in checkBoxGroup" :key="item" style="width: 80px; margin-bottom: 5px" :label="item" :value="item"></el-checkbox>
						</el-checkbox-group>
						<template #reference>
							<el-button type="primary" size="small" plain>
								<i class="el-icon-arrow-down el-icon-menu" />
								&nbsp;
							</el-button>
						</template>
					</el-popover>
				</el-form-item>
			</el-form>
			<!--列表-->
			<STable
				:columns="columnsData"
				:data="listData"
				:loading="loading"
				:row-key="'keyId'"
				:tree-props="{ children: 'subModules', hasChildren: 'hasChildren' }"
				@get-data="getListData"
				@handle-command="handleCommand"
			>
				<template #icon>
					<el-table-column align="center" prop="icon" label="图标">
						<template #default="scope">
							<i :class="scope.row.icon"></i>
						</template>
					</el-table-column>
				</template>
				<template #color>
					<el-table-column align="center" label="颜色" prop="color" min-width="80">
						<template #default="scope">
							<el-tag class="colorG" :color="scope.row.color"></el-tag>
						</template>
					</el-table-column>
				</template>
				<template #switch>
					<el-table-column align="center" prop="isShow" label="是否显示">
						<template #default="scope">
							<el-switch v-model="scope.row.isShow" active-color="#13ce66" inactive-color="" @change="editType(scope.row)"></el-switch>
						</template>
					</el-table-column>
				</template>
			</STable>
		</div>

		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		<!-- 编辑 -->
		<edit ref="edit" :module-type-list="moduleTypeList" :module-sub-type-list="moduleSubTypeList"></edit>
	</div>
</template>

<script>
import { GetModuleTreeList, DeleteModuleInfo, SaveModule, GetEnumListByName } from "../../../api/systemApi.js";
import edit from "./edit";
export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			columnsData: [], //显示列
			checkBoxGroup: [], //所有列
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				moduleName: ""
			},
			checkedColumns: [], //勾选列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					prop: "moduleName",
					label: "模块名称"
				},
				{
					prop: "moduleCode",
					label: "模块编号"
				},
				{
					prop: "moduleTypeTxt",
					label: "模块类型"
				},
				{
					prop: "moduleSubTypeTxt",
					label: "模块子类型"
				},
				{
					prop: "moduleUrl",
					label: "模块地址"
				},
				{
					slot: "icon",
					label: "图标"
				},
				{
					slot: "color",
					label: "颜色"
				},
				{
					prop: "seq",
					label: "显示顺序"
				},
				{
					slot: "switch",
					label: "是否显示"
				},
				{
					operation: true,
					btnGroup: [
						{
							icon: "el-icon-plus",
							name: "新增",
							type: "1",
							btnType: ""
						},
						{
							icon: "el-icon-edit",
							name: "编辑",
							type: "2",
							btnType: "primary"
						},
						{
							icon: "el-icon-delete",
							name: "删除",
							type: "3",
							btnType: "danger"
						}
					]
				}
			],
			moduleTypeList: [],
			moduleSubTypeList: [],
			topList: [
				{
					name: "系统基础配置"
				}
			]
		};
	},
	// 注册组件
	components: {
		edit
	},
	created() {
		let route = {
			name: this.$route.name,
			path: this.$route.path
		};
		this.topList.push(route);
		this.getListData();
		this.GetEnum();
		// 初始列
		this.listColumns.forEach((item) => {
			if (item.label) {
				this.checkBoxGroup.push(item.label);
			}
		});
		this.checkedColumns = ["序号", "模块名称", "模块编号", "模块类型", "模块子类型", "模块地址", "图标", "颜色", "显示顺序", "是否显示"];
	},
	watch: {
		// 列筛选
		checkedColumns(val) {
			let arr = this.checkBoxGroup.filter((v) => !val.includes(v));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i.label));
		}
	},
	computed: {},
	methods: {
		// 新增子菜单
		addModule(row) {
			this.$refs.edit.addModule(row);
		},
		editType(row) {
			SaveModule(row)
				.then((res) => {
					this.loading = false;
					if (res.code === 1) {
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						setTimeout(() => {
							this.getListData();
						}, 500);
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},

		handleCommand(command) {
			switch (command.command) {
				case "1":
					this.addModule(command.rowData);
					break;
				case "2":
					this.handleEdit(command.rowData);
					break;
				case "3":
					this.deleteMenu(command.rowData);
					break;
				default:
					console.log(command);
			}
		},
		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row);
		},
		// 删除
		deleteMenu(row) {
			this.$confirm("确定要删除<" + row.moduleName + ">吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyId: row.keyId
				};
				DeleteModuleInfo(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetModuleTreeList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data.map((item) => {
							this.moduleSubTypeList.map((v) => {
								if (v.keyId == item.moduleSubType) {
									item.moduleSubTypeTxt = v.value;
								}
							});
							this.moduleTypeList.map((v) => {
								if (v.keyId == item.moduleType) {
									item.moduleTypeTxt = v.value;
								}
							});
							return item;
						});
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 枚举
		GetEnum() {
			GetEnumListByName({
				enumName: "ModuleType"
			})
				.then((res) => {
					if (res.code === 1) {
						this.moduleTypeList = res.data;
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
			GetEnumListByName({
				enumName: "ModuleSubType"
			})
				.then((res) => {
					if (res.code === 1) {
						this.moduleSubTypeList = res.data;
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		}
	}
};
</script>

<style scoped>
.colorG {
	width: 100%;
}
</style>
